export default __webpack_public_path__ + "static/media/clear-night.17ac83aa.svg";